module.exports = __webpack_public_path__ + "img/66605E_939198_2E261F_3C332A-256px.9780b3ef.png";